// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {compose, lifecycle} from 'recompose'

import ClientList from '../components/ClientList/ClientList'
import * as actions from '../actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {AdminState} from '../types/index'

export type StateProps = {
  clients: $PropertyType<AdminState, 'clients'>,
  accountManagers: $PropertyType<AdminState, 'accountManagers'>,
  companies: $PropertyType<AdminState, 'companies'>,
  isLoadingAccountManagers: $PropertyType<AdminState, 'isLoadingAccountManagers'>,
  isInvitingClient: $PropertyType<AdminState, 'isInvitingClient'>,
  error: $PropertyType<AdminState, 'error'>,
  isLoadingCompaniesSuggestion: $PropertyType<AdminState, 'isLoadingCompaniesSuggestion'>,
  companiesSuggestion: $PropertyType<AdminState, 'companiesSuggestion'>,
  isLoadingAccountManagersSuggestion: $PropertyType<AdminState, 'isLoadingAccountManagersSuggestion'>,
  accountManagersSuggestion: $PropertyType<AdminState, 'accountManagersSuggestion'>
};

export type OwnProps = {
  companyId?: ?string,
  isSubScreen?: boolean,
  companyName?: string
};

export type DispatchProps = {
  getAccountManagers: $PropertyType<typeof actions, 'getAccountManagers'>,
  getClients: $PropertyType<typeof actions, 'getClients'>,
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  inviteNewClient: $PropertyType<typeof actions, 'inviteNewClient'>,
  getCompaniesSuggestion: $PropertyType<typeof actions, 'getCompaniesSuggestion'>,
  getAccountManagersSuggestion: $PropertyType<typeof actions, 'getAccountManagersSuggestion'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = state => {
  return {
    clients: state.admin.clients,
    accountManagers: state.admin.accountManagers,
    isLoadingAccountManagers: state.admin.isLoadingAccountManagers,
    companies: state.admin.companies,
    isInvitingClient: state.admin.isInvitingClient,
    error: state.admin.error,
    isLoadingCompaniesSuggestion: state.admin.isLoadingCompaniesSuggestion,
    companiesSuggestion: state.admin.companiesSuggestion,
    isLoadingAccountManagersSuggestion: state.admin.isLoadingAccountManagersSuggestion,
    accountManagersSuggestion: state.admin.accountManagersSuggestion
  }
}

const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {}
  })
)(ClientList)
